import {
  INFlag,
  USFlag,
  CAFlag,
  GBFlag,
  AUFlag,
  CNFlag,
  JPFlag,
  DEFlag,
  FRFlag,
  BRFlag,
  ZAFlag,
  RUFlag,
  MXFlag,
  IDFlag,
  PKFlag,
  BDFlag,
  PHFlag,
  EGFlag,
  VNFlag,
  TRFlag,
  ITFlag,
  ESFlag,
  ARFlag,
  SAFlag,
  MYFlag,
  GRFlag,
  SEFlag,
  AEFlag,
  NLFlag,
  COFlag,
  CLFlag,
  HKFlag,
  SGFlag,
  CHFlag,
  IEFlag,
  PLFlag,
  ILFlag,
  PEFlag,
  NOFlag,
  BEFlag,
  DKFlag,
  ATFlag,
  FIFlag,
  KRFlag,
  THFlag,
  IRFlag,
  IQFlag,
  JOFlag,
  LBFlag,
  KWFlag,
  QAFlag,
  OMFlag,
  BHFlag,
  YEFlag,
  SYFlag,
  MMFlag,
  KHFlag,
  LAFlag,
  BNFlag,
  TLFlag,
  MVFlag,
  PGFlag,
  FJFlag,
  SBFlag,
  VUFlag,
  WSFlag,
  TOFlag,
  KIFlag,
  FMFlag,
  NZFlag,
} from "mantine-flagpack";

const FlagExporter = ({ countryName }) => {
  const mapping = {
    India: <INFlag w={24} radius="sm" />,
    "United States (USA)": <USFlag w={24} radius="sm" />,
    Canada: <CAFlag w={24} radius="sm" />,
    "United Kingdom (UK)": <GBFlag w={24} radius="sm" />,
    Australia: <AUFlag w={24} radius="sm" />,
    China: <CNFlag w={24} radius="sm" />,
    Japan: <JPFlag w={24} radius="sm" />,
    Germany: <DEFlag w={24} radius="sm" />,
    France: <FRFlag w={24} radius="sm" />,
    Brazil: <BRFlag w={24} radius="sm" />,
    "South Africa": <ZAFlag w={24} radius="sm" />,
    Russia: <RUFlag w={24} radius="sm" />,
    Mexico: <MXFlag w={24} radius="sm" />,
    Indonesia: <IDFlag w={24} radius="sm" />,
    Pakistan: <PKFlag w={24} radius="sm" />,
    Bangladesh: <BDFlag w={24} radius="sm" />,
    Philippines: <PHFlag w={24} radius="sm" />,
    Egypt: <EGFlag w={24} radius="sm" />,
    Vietnam: <VNFlag w={24} radius="sm" />,
    Turkey: <TRFlag w={24} radius="sm" />,
    Italy: <ITFlag w={24} radius="sm" />,
    Spain: <ESFlag w={24} radius="sm" />,
    Argentina: <ARFlag w={24} radius="sm" />,
    "Saudi Arabia": <SAFlag w={24} radius="sm" />,
    Malaysia: <MYFlag w={24} radius="sm" />,
    Greece: <GRFlag w={24} radius="sm" />,
    Sweden: <SEFlag w={24} radius="sm" />,
    "UAE (United Arab Emirates)": <AEFlag w={24} radius="sm" />,
    Netherlands: <NLFlag w={24} radius="sm" />,
    Colombia: <COFlag w={24} radius="sm" />,
    Chile: <CLFlag w={24} radius="sm" />,
    "Hong Kong": <HKFlag w={24} radius="sm" />,
    Singapore: <SGFlag w={24} radius="sm" />,
    Switzerland: <CHFlag w={24} radius="sm" />,
    Ireland: <IEFlag w={24} radius="sm" />,
    Poland: <PLFlag w={24} radius="sm" />,
    Israel: <ILFlag w={24} radius="sm" />,
    Peru: <PEFlag w={24} radius="sm" />,
    Norway: <NOFlag w={24} radius="sm" />,
    "New Zealand": <NZFlag w={24} radius="sm" />,
    Belgium: <BEFlag w={24} radius="sm" />,
    Denmark: <DKFlag w={24} radius="sm" />,
    Austria: <ATFlag w={24} radius="sm" />,
    Finland: <FIFlag w={24} radius="sm" />,
    "South Korea": <KRFlag w={24} radius="sm" />,
    Thailand: <THFlag w={24} radius="sm" />,
    Iran: <IRFlag w={24} radius="sm" />,
    Iraq: <IQFlag w={24} radius="sm" />,
    Jordan: <JOFlag w={24} radius="sm" />,
    Lebanon: <LBFlag w={24} radius="sm" />,
    Kuwait: <KWFlag w={24} radius="sm" />,
    Qatar: <QAFlag w={24} radius="sm" />,
    Oman: <OMFlag w={24} radius="sm" />,
    Bahrain: <BHFlag w={24} radius="sm" />,
    Yemen: <YEFlag w={24} radius="sm" />,
    Syria: <SYFlag w={24} radius="sm" />,
    "Myanmar (Burma)": <MMFlag w={24} radius="sm" />,
    Cambodia: <KHFlag w={24} radius="sm" />,
    Laos: <LAFlag w={24} radius="sm" />,
    Brunei: <BNFlag w={24} radius="sm" />,
    "East Timor (Timor-Leste)": <TLFlag w={24} radius="sm" />,
    Maldives: <MVFlag w={24} radius="sm" />,
    "Papua New Guinea": <PGFlag w={24} radius="sm" />,
    Fiji: <FJFlag w={24} radius="sm" />,
    "Solomon Islands": <SBFlag w={24} radius="sm" />,
    Vanuatu: <VUFlag w={24} radius="sm" />,
    Samoa: <WSFlag w={24} radius="sm" />,
    Tonga: <TOFlag w={24} radius="sm" />,
    Kiribati: <KIFlag w={24} radius="sm" />,
    Micronesia: <FMFlag w={24} radius="sm" />,
  };
  return mapping[countryName] || <FMFlag w={24} radius="sm" />;
};

export default FlagExporter;
